import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção dos demais relatórios de médico). */
export type CertidaoEmeMedicoJob = ReportJob;
export type CertidaoEmeMedicoJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Certidão EME. */
@Injectable({ providedIn: 'root' })
export class CertidaoEmeMedicoJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'certidao-eme-medico-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.medico.reports.certidaoEmeMedico;
}
